import {
  Box,
  IconButton,
  useTheme,
  Badge,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  Popover,
  Button,
} from "@mui/material";
import React, { useContext, useState, useEffect } from "react";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import UserWidget from "../../components/OperadorWidget";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLogout } from "../../state";
import { getAvisosPendientes } from "../../services";

const Topbar = ({ isAuthenticated = true }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const datosOperador = useSelector((state) => state.dataEmpleado);
  const usuarioSitae = useSelector((state) => state.user);

  // Estado separado para cada menú
  const [anchorElNotifications, setAnchorElNotifications] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [listaAvisos, setListaAvisos] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const avisos = await getAvisosPendientes(usuarioSitae);
        setListaAvisos(avisos);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [usuarioSitae]);

  // Handlers para el menú de notificaciones
  const handleOpenNotifications = (event) => {
    setAnchorElNotifications(event.currentTarget);
  };
  const handleCloseNotifications = () => {
    setAnchorElNotifications(null);
  };

  // Handlers para el popover del usuario
  const handleOpenUser = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUser = () => {
    setAnchorElUser(null);
  };

  // Función para cerrar sesión
  const logOut = () => {
    setAnchorElUser(null);
    dispatch(setLogout());
    navigate("/");
  };

  return (
    <Box display={isAuthenticated ? "flex" : "none"} justifyContent="space-between" p={2}>
      {/* SEARCH BAR (oculto por ahora) */}
      <Box display="flex" backgroundColor={colors.primary[400]} borderRadius="3px">
        {/* <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton> */}
      </Box>

      {/* ICONOS */}
      <Box display="flex">
        {/* Modo Oscuro/Claro */}
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
        </IconButton>

        {/* Notificaciones */}
        <IconButton onClick={handleOpenNotifications}>
          <Badge
            badgeContent={listaAvisos.length}
            color="error"
            overlap="circular"
            sx={{
              "& .MuiBadge-badge": {
                fontSize: "0.7rem",
                minWidth: "16px",
                height: "16px",
              },
            }}
          >
            <NotificationsOutlinedIcon />
          </Badge>
        </IconButton>

        {/* Menú de Notificaciones */}
        <Menu
          anchorEl={anchorElNotifications}
          open={Boolean(anchorElNotifications)}
          onClose={handleCloseNotifications}
          PaperProps={{
            style: {
              maxHeight: 200, // Limita la altura del menú
              width: "300px",
            },
          }}
        >
          {listaAvisos.length > 0 ? (
            <List>
              {listaAvisos.map((notification, index) => (
                <ListItem key={index} divider>
                  <ListItemText primary={`Documentación pendiente en aviso: ${notification.id}`} />
                </ListItem>
              ))}
            </List>
          ) : (
            <MenuItem onClick={handleCloseNotifications}>
              <Typography>No hay notificaciones</Typography>
            </MenuItem>
          )}
        </Menu>

        {/* Configuración */}
        {/* <IconButton>
          <SettingsOutlinedIcon />
        </IconButton> */}

        {/* Usuario */}
        <Box display="flex" alignItems="center">
          <IconButton aria-describedby="user-popover" onClick={handleOpenUser}>
            <PersonOutlinedIcon />
          </IconButton>

          {/* Popover para mostrar el UserWidget */}
          <Popover
            id="user-popover"
            open={Boolean(anchorElUser)}
            anchorEl={anchorElUser}
            onClose={handleCloseUser}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            PaperProps={{
              sx: {
                p: 2,
                borderRadius: "10px",
                boxShadow: 3,
                maxWidth: 300,
              },
            }}
          >
            <UserWidget
              isCompact={true}
              codigoOperador={datosOperador[0]?.Codigo}
              nombreOperador={datosOperador[0]?.Operador}
            />
            {/* Divider para separar */}
            <Box mt={2} borderTop={`1px solid ${theme.palette.divider}`} />

            {/* Botón de Logout */}
            <Box display="flex" justifyContent="center" mt={2}>
              <Button
                variant="contained"
                color="error"
                startIcon={<PersonOutlinedIcon />}
                onClick={logOut}
                sx={{ width: "100%" }} // Que ocupe todo el ancho
              >
                Cerrar Sesión
              </Button>
            </Box>
          </Popover>
        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;
